var _rect, _path, _g, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarningsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.93164,
    y: 2.45703,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#4C4577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.249 3.45703C20.249 2.90475 19.8013 2.45703 19.249 2.45703C18.6967 2.45703 18.249 2.90475 18.249 3.45703V5.45703H16.249C15.6967 5.45703 15.249 5.90475 15.249 6.45703C15.249 7.00932 15.6967 7.45703 16.249 7.45703H18.249V9.45703C18.249 10.0093 18.6967 10.457 19.249 10.457C19.8013 10.457 20.249 10.0093 20.249 9.45703V7.45703H22.249C22.8013 7.45703 23.249 7.00932 23.249 6.45703C23.249 5.90475 22.8013 5.45703 22.249 5.45703H20.249V3.45703Z",
    fill: "#F8F5FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_42_15585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8712 25.5979C28.8712 31.3146 24.2368 35.9489 18.52 35.9489C12.8032 35.9489 8.16882 31.3146 8.16882 25.5979C8.16882 19.8813 12.8032 15.2469 18.52 15.2469C24.2368 15.2469 28.8712 19.8813 28.8712 25.5979Z",
    fill: "#E3D7FB",
    stroke: "#CCB7F8",
    strokeWidth: 2.33763
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5155 22.6119C18.2204 22.6077 17.9399 22.6555 17.6739 22.7552C17.4121 22.8508 17.1981 22.9817 17.0319 23.148C16.8656 23.3142 16.7825 23.5053 16.7825 23.7214C16.7825 23.9999 16.8594 24.2097 17.0132 24.351C17.1711 24.4923 17.381 24.5962 17.6428 24.6627C17.9046 24.7251 18.1955 24.7832 18.5155 24.8373C19.0973 24.9287 19.6355 25.0825 20.13 25.2986C20.6246 25.5147 21.0215 25.8035 21.3207 26.165C21.6199 26.5224 21.7695 26.9609 21.7695 27.4803C21.7695 27.9541 21.6469 28.3759 21.4017 28.7458C21.1565 29.1115 20.8261 29.4107 20.4106 29.6434C19.9991 29.8761 19.542 30.0236 19.0391 30.086V31.3576H17.9981V30.086C17.5784 30.0361 17.1836 29.9301 16.8137 29.7681C16.4438 29.606 16.1217 29.3941 15.8475 29.1322C15.5773 28.8704 15.3779 28.565 15.249 28.2159L16.6766 27.6923C16.7347 27.8585 16.8532 28.0102 17.0319 28.1473C17.2106 28.2845 17.4288 28.3946 17.6864 28.4777C17.9441 28.5608 18.2204 28.6024 18.5155 28.6024C18.8189 28.6024 19.1015 28.5567 19.3633 28.4652C19.6293 28.3697 19.8433 28.2388 20.0054 28.0725C20.1674 27.9021 20.2485 27.7047 20.2485 27.4803C20.2485 27.2518 20.1633 27.0648 19.9929 26.9193C19.8225 26.7697 19.6043 26.6513 19.3384 26.564C19.0724 26.4767 18.7981 26.4102 18.5155 26.3645C17.8963 26.2689 17.3415 26.1214 16.8511 25.9219C16.3607 25.7224 15.9721 25.4461 15.6854 25.0928C15.4028 24.7396 15.2615 24.2825 15.2615 23.7214C15.2615 23.2477 15.3841 22.8259 15.6293 22.456C15.8786 22.0862 16.209 21.7869 16.6204 21.5584C17.036 21.3257 17.4952 21.1781 17.9981 21.1158V19.8379H19.0391V21.1158C19.4506 21.1657 19.8412 21.2716 20.2111 21.4337C20.581 21.5958 20.903 21.8098 21.1773 22.0758C21.4558 22.3376 21.6594 22.6451 21.7882 22.9983L20.3545 23.5157C20.2963 23.3495 20.1778 23.1978 19.9991 23.0607C19.8204 22.9235 19.6023 22.8155 19.3446 22.7365C19.0869 22.6534 18.8106 22.6119 18.5155 22.6119Z",
    fill: "#67548E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9214 26.0635C41.9214 28.2967 40.111 30.107 37.8779 30.107C35.6448 30.107 33.8345 28.2967 33.8345 26.0635C33.8345 23.8304 35.6448 22.0201 37.8779 22.0201C40.111 22.0201 41.9214 23.8304 41.9214 26.0635Z",
    fill: "#987DD2",
    stroke: "#B292F4",
    strokeWidth: 0.913151
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8767 24.8972C37.7614 24.8955 37.6518 24.9142 37.5479 24.9532C37.4457 24.9905 37.3621 25.0416 37.2971 25.1066C37.2322 25.1715 37.1997 25.2462 37.1997 25.3306C37.1997 25.4394 37.2298 25.5213 37.2898 25.5765C37.3515 25.6317 37.4335 25.6723 37.5358 25.6983C37.638 25.7226 37.7517 25.7454 37.8767 25.7665C38.1039 25.8022 38.3142 25.8623 38.5074 25.9467C38.7005 26.0311 38.8556 26.1439 38.9725 26.2851C39.0893 26.4248 39.1478 26.596 39.1478 26.799C39.1478 26.984 39.0999 27.1488 39.0041 27.2933C38.9083 27.4361 38.7793 27.553 38.6169 27.6439C38.4562 27.7348 38.2776 27.7925 38.0812 27.8168V28.3136H37.6746V27.8168C37.5106 27.7973 37.3564 27.7559 37.2119 27.6926C37.0674 27.6293 36.9416 27.5465 36.8345 27.4443C36.729 27.342 36.651 27.2227 36.6007 27.0863L37.1583 26.8817C37.1811 26.9467 37.2273 27.0059 37.2971 27.0595C37.3669 27.1131 37.4522 27.1561 37.5528 27.1886C37.6535 27.221 37.7614 27.2373 37.8767 27.2373C37.9952 27.2373 38.1056 27.2194 38.2078 27.1837C38.3117 27.1464 38.3953 27.0952 38.4587 27.0303C38.522 26.9637 38.5536 26.8866 38.5536 26.799C38.5536 26.7097 38.5203 26.6366 38.4538 26.5798C38.3872 26.5214 38.302 26.4751 38.1981 26.441C38.0942 26.4069 37.9871 26.3809 37.8767 26.3631C37.6348 26.3257 37.4181 26.2681 37.2265 26.1902C37.035 26.1123 36.8832 26.0043 36.7712 25.8663C36.6608 25.7283 36.6056 25.5498 36.6056 25.3306C36.6056 25.1455 36.6535 24.9808 36.7492 24.8363C36.8466 24.6918 36.9757 24.5749 37.1364 24.4856C37.2988 24.3947 37.4781 24.3371 37.6746 24.3127V23.8135H38.0812V24.3127C38.2419 24.3322 38.3945 24.3736 38.539 24.4369C38.6835 24.5002 38.8093 24.5838 38.9164 24.6877C39.0252 24.79 39.1048 24.9101 39.1551 25.0481L38.595 25.2502C38.5723 25.1853 38.526 25.126 38.4562 25.0725C38.3864 25.0189 38.3012 24.9767 38.2005 24.9459C38.0999 24.9134 37.9919 24.8972 37.8767 24.8972Z",
    fill: "#483B64"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_42_15585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5562 10.4569C41.5562 14.03 38.6597 16.9265 35.0867 16.9265C31.5137 16.9265 28.6172 14.03 28.6172 10.4569C28.6172 6.88387 31.5137 3.98736 35.0867 3.98736C38.6597 3.98736 41.5562 6.88387 41.5562 10.4569Z",
    fill: "#CCB7F8",
    stroke: "#B292F4",
    strokeWidth: 1.46104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0847 8.59071C34.9003 8.58812 34.725 8.61799 34.5587 8.68033C34.3951 8.74007 34.2613 8.82189 34.1574 8.92578C34.0535 9.02968 34.0016 9.14916 34.0016 9.28423C34.0016 9.45825 34.0496 9.58942 34.1457 9.67774C34.2444 9.76605 34.3756 9.83098 34.5392 9.87254C34.7029 9.9115 34.8847 9.94787 35.0847 9.98164C35.4483 10.0388 35.7847 10.1349 36.0938 10.2699C36.4029 10.405 36.6509 10.5855 36.8379 10.8115C37.025 11.0349 37.1185 11.3089 37.1185 11.6336C37.1185 11.9297 37.0418 12.1933 36.8886 12.4245C36.7353 12.6531 36.5289 12.8401 36.2691 12.9856C36.012 13.131 35.7263 13.2232 35.412 13.2622V14.057H34.7613V13.2622C34.499 13.231 34.2522 13.1648 34.0211 13.0635C33.7899 12.9622 33.5886 12.8297 33.4172 12.6661C33.2483 12.5024 33.1237 12.3115 33.0432 12.0933L33.9354 11.7661C33.9717 11.87 34.0457 11.9648 34.1574 12.0505C34.2691 12.1362 34.4055 12.205 34.5665 12.257C34.7276 12.3089 34.9003 12.3349 35.0847 12.3349C35.2743 12.3349 35.4509 12.3063 35.6146 12.2492C35.7808 12.1894 35.9146 12.1076 36.0159 12.0037C36.1172 11.8972 36.1678 11.7739 36.1678 11.6336C36.1678 11.4907 36.1146 11.3739 36.0081 11.2829C35.9016 11.1894 35.7652 11.1154 35.599 11.0609C35.4328 11.0063 35.2613 10.9648 35.0847 10.9362C34.6977 10.8764 34.3509 10.7842 34.0444 10.6596C33.738 10.5349 33.4951 10.3622 33.3159 10.1414C33.1393 9.9206 33.0509 9.63488 33.0509 9.28423C33.0509 8.98812 33.1276 8.72448 33.2808 8.49331C33.4367 8.26214 33.6431 8.07513 33.9003 7.93227C34.16 7.78681 34.447 7.6946 34.7613 7.65564V6.85693H35.412V7.65564C35.6691 7.68681 35.9133 7.75305 36.1444 7.85434C36.3756 7.95564 36.5769 8.08941 36.7483 8.25565C36.9224 8.41928 37.0496 8.61149 37.1301 8.83227L36.234 9.15565C36.1977 9.05176 36.1237 8.95695 36.012 8.87124C35.9003 8.78552 35.7639 8.71799 35.6029 8.66864C35.4418 8.61669 35.2691 8.59071 35.0847 8.59071Z",
    fill: "#524372"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_42_15585",
    x: 0,
    y: 14.0781,
    width: 37.04,
    height: 40.0396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_42_15585",
    result: "effect2_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_42_15585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_42_15585",
    x: 20.8867,
    y: 3.25684,
    width: 28.4,
    height: 31.4001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_42_15585",
    result: "effect2_dropShadow_42_15585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_42_15585",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningsIcon);
export default __webpack_public_path__ + "static/media/earnings-icon.fdcf94c9b4c3f55d63c53386fb24540d.svg";
export { ForwardRef as ReactComponent };